import { NaverMapAdapter } from './NaverMapAdapter';
import { KakaoMapAdapter } from './KakaoMapAdapter';
import type { MapAdapter } from './MapAdapter';

export function createMapAdapter(providerKey: string): MapAdapter {
    if (providerKey === 'kakao') return new KakaoMapAdapter();
    return new NaverMapAdapter();
}
